import { ApiHelper } from './apiHelper';
import { ProductData, ProductFilter } from '../components/common/CommonTypes';

/**
 * Client-side API wrapper for product catalogue endpoints.
 */
export class ProductApi {
  /**
   * Fetches (filters) the product catalogue.
   *
   * @param productFilter Filter criteria used by the backend to select products.
   * @param token Bearer token used for authenticated requests.
   * @param successCallback Invoked with product data on success.
   * @param failureCallback Invoked when the request fails.
   * @param signal Abort signal used to cancel the request.
   */
  getProducts(
    productFilter: ProductFilter,
    token: string,
    successCallback: (product: ProductData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const dataUrl = '/api/product/getProducts';

    new ApiHelper().postDataSecureAsync(
      dataUrl,
      productFilter,
      token,
      successCallback,
      failureCallback,
      signal,
      { retryAttempts: 1 }
    );
  }
}
